import { useState } from "react";
import { Globe } from "lucide-react";
import CountryPicker from "./CountryPicker";
import { countryName, setRegion } from "../lib/region";

// Subtle browsing-region indicator + deliberate "Change region" control.
// The detected/default region comes from the server (IP-based); picking a
// country here is the sanctioned intentional override (session-scoped).
export default function RegionChip({ region, onChange, testId = "region-chip" }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!region) return null;

  const pick = async (cc) => {
    setBusy(true);
    try { onChange(await setRegion(cc)); }
    finally { setBusy(false); setOpen(false); }
  };

  return (
    <span className="relative inline-block" data-testid={testId}>
      <button type="button" onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }} disabled={busy}
              data-testid={`${testId}-toggle`} aria-haspopup="listbox" aria-expanded={open}
              className="inline-flex items-center gap-1.5 rounded-full border border-[#27272A] bg-[#0A0D10] px-3 py-1.5 text-[11px] text-zinc-400 hover:text-zinc-200 hover:border-[#3F3F46] transition-colors disabled:opacity-50">
        <Globe className="w-3.5 h-3.5 text-[#FF3B45]" />
        {region.country ? (
          <>Browsing: <span className="text-zinc-200 font-medium">{countryName(region.country)}</span>
            {region.source === "override" && <span className="text-zinc-600">(selected)</span>}</>
        ) : "Set your region"}
      </button>
      {open && (
        <div className="absolute z-40 mt-2 w-64 left-0" data-testid={`${testId}-popover`}>
          <CountryPicker value={region.country || ""} onChange={pick} testId={`${testId}-picker`} disabled={busy} autoOpen />
        </div>
      )}
    </span>
  );
}
